export default "__VITE_ASSET__CaDMzbMY__"